<template>
  <div class="ListingPage">
    <div v-if="slug">
      <ArtistStudioPostWithQuery :slug="slug" />
    </div>
    <div v-else>
      <ArtistStudioPostsWithQuery />
    </div>
  </div>
</template>

<script setup>
import ArtistStudioPostWithQuery from "@/pages/ArtistProfilePage/ArtistStudioPostWithQuery.vue"
import ArtistStudioPostsWithQuery from "@/pages/ArtistProfilePage/ArtistStudioPostsWithQuery.vue"

import { inject } from "vue"

const slug = inject("studioPostSlug")
</script>

<script>
export default {
  name: "ArtistStudio",
}
</script>

<style lang="scss" scoped>
::v-deep .ListingGrid {
  display: grid;
  grid-gap: 30px;
  row-gap: 60px;
  grid-template: auto / repeat(1, 1fr);

  @media screen and (max-width: theme("screens.md") - 1px) {
    margin-top: 30px;
    &.view-list {
      display: block;
      ::v-deep .ArtistStudioPost {
        margin-bottom: 30px;
      }
    }
  }

  @media (min-width: theme("screens.md")) {
    min-height: 450px;
    grid-template: auto / repeat(1, 1fr);
  }

  &-loading {
    margin-top: 150px;
    min-height: 500px;
    font-size: 15rem;
    position: sticky;
    top: 250px;
    bottom: 250px;
  }
}

::v-deep .ArtistStudioPost {
  min-width: 0;
  min-height: 0;
  -ms-overflow-style: none;

  .tooltip-inner {
    width: 80px;
  }
}
</style>
